import { HttpClient, HttpMethods } from "@planzone/services";

type Response = {
  access_token: string;
  refresh_token: string;
  expires_in: number;
};

const casUrl = process.env.CAS_CLIENT_ID;

function refreshToken(
  httpClient: HttpClient,
  refreshToken: string,
): Promise<{
  accessToken: string;
  refreshToken: string;
  expiresAt: number;
}> {
  return httpClient
    .sendHttpRequest<Response>({
      baseUrl: "/cas",
      endpoint:
        `/oidc/accessToken?` +
        "grant_type=refresh_token" +
        `&refresh_token=${refreshToken}` +
        `&client_id=${casUrl}`,
      method: HttpMethods.GET,
      headers: { Authorization: "" },
    })
    .then(({ access_token, refresh_token, expires_in }) => ({
      accessToken: access_token,
      refreshToken: refresh_token,
      expiresAt: new Date().getTime() + expires_in - 5000,
    }));
}

export { refreshToken };
